import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromAOM } from 'core/contexts/device-types';
import { SettingsOperatorCustomNotificationsContainer } from 'modules/settings/pods/settings-operator-custom-notifications';

const SettingsOperatorCustomNotificationsScene: React.FC = () => (
    <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromAOM} source={DEVICE_TYPE_SOURCE.AOM}>
        <SettingsOperatorCustomNotificationsContainer />
    </DeviceTypesProvider>
);

export default SettingsOperatorCustomNotificationsScene;
